module.exports = __webpack_public_path__ + "img/genicon-confirm-special.231d685a.svg";